export default class WelcomeCentreService {
  constructor($http, appConfig) {
    "ngInject";

    this._$http = $http;
    this._appConfig = appConfig
  }

}



// WEBPACK FOOTER //
// ./client/app/components/welcomeCentre/welcomeCentre.service.js